import type { OptionsDocument } from 'paintscout'
import { useAddressSearch } from 'shared/hooks/useAddressSearch'

// Handle Contact address search logic
// This is a wrapper around useAddressSearch that maintains backward compatibility
// with the isInitialLoad parameter and updateQuery return value
export const useContactAddressSearch = ({
  options,
  isInitialLoad
}: {
  options: OptionsDocument
  isInitialLoad: boolean
}): {
  addressSearchResults: any
  fetching: boolean
  error: any
  locationQuery: string
  updateQuery: any
  debouncedAddressSearch: any
} => {
  const { addressSearchResults, fetching, error, locationQuery, debouncedAddressSearch } = useAddressSearch({
    options,
    skip: isInitialLoad
  })

  // updateQuery is kept for backward compatibility but is a no-op
  const updateQuery = () => {
    // No-op for backward compatibility
  }

  return {
    addressSearchResults,
    fetching,
    error,
    locationQuery,
    updateQuery,
    debouncedAddressSearch
  }
}
